import { render, staticRenderFns } from "./RsaConfigurazioneParametriVitaliListComponent.vue?vue&type=template&id=811990a6"
import script from "./RsaConfigurazioneParametriVitaliListComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneParametriVitaliListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports